import app from "../_app";
export function loader() {
    return `<div class="spinner-border c--c m-5" role="status"><span class="visually-hidden">${app.translationHelper('general.loading')}</span></div>`;
}

